module.exports = __webpack_public_path__ + "img/mastercard-small.7a439f00.png";